import React from 'react';
import { connect } from 'react-redux';
import {showLoader} from "../../utils";
import {
    getIsFormValidating, getIsLoadingUsernameCheck, getPassword,
    getUsername, getUsernameMessage, getUsernameStatus
} from "../../selectors";
import {
    changeUsername, validateForm,
} from "../../reducers";

const stateToProps = state => ({
    usernameStatus: getUsernameStatus(state),
    isLoadingUsernameCheck: getIsLoadingUsernameCheck(state),
    username: getUsername(state),
    password: getPassword(state),
    isFormValidating: getIsFormValidating(state),
    usernameMessage: getUsernameMessage(state),
});

const actionsToProps = dispatch => ({
    changeUsername: payload => dispatch(changeUsername(payload)),
    validateForm: payload => dispatch(validateForm(payload)),
});

const Username = props => {

    const checkUsername = () => {
        if (props.username !== '') {
            if (props.password !== '') {
                props.checkPasswordAndValidateForm('username');
            } else {
                props.validateForm({updatedField: 'username'});
            }
        } else {
            props.changeUsername({ usernameStatus: 'none', usernameMessage: '' });
        }
    };


    return (
        <div className={`form-row ${props.usernameStatus}`}>
            <label className="form-label" htmlFor="username">
                {props.isLoadingUsernameCheck && showLoader()}
                Username <span className="asterisk">*</span>
            </label>

            <input type="text" className="form-input" id="username" onBlur={checkUsername} value={props.username}
                   disabled={props.isFormValidating}
                   onChange={e => {
                       const username = e.target.value.trim();
                       if (username.length <= 14) {
                           props.changeUsername({
                               username: username,
                               usernameStatus: 'none',
                               usernameMessage: '',
                           })}
                   }
                   }
            />

            <p className="callout error p10 txt-l">{props.usernameMessage}</p>
            <i className="form-status" />
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(Username);
